import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import NueraLogo from "@/components/NueraLogo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("keerthana.cs@gmail.com");
  const [password, setPassword] = useState("Nuera@2026");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back to Nuera");
      navigate(res.org && !res.org.onboarded ? "/onboarding" : "/");
    } else setError(res.error);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm animate-fade-up">
          <div className="mb-8"><NueraLogo className="h-8 w-auto" /></div>
          <h1 className="font-heading text-3xl font-bold tracking-tight">Welcome back</h1>
          <p className="mt-2 text-muted-foreground">Sign in to your marketing command centre.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
            <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full rounded-full bg-brand-primary text-brand-primary-foreground hover:opacity-90">
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Sign in
            </Button>
          </form>
          <p className="mt-6 text-sm text-muted-foreground">
            New to Nuera?{" "}
            <Link to="/register" data-testid="to-register" className="font-semibold text-brand-primary hover:underline">Create an account</Link>
          </p>
        </div>
      </div>
      <div className="relative hidden overflow-hidden bg-primary lg:block">
        <img src="https://images.unsplash.com/photo-1758270705657-f28eec1a5694?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-primary via-primary/70 to-transparent" />
        <div className="absolute bottom-0 p-12 text-primary-foreground">
          <p className="font-heading text-3xl font-bold leading-tight">Your marketing,<br />not just your data.</p>
          <p className="mt-3 max-w-md text-primary-foreground/70">Nuera turns Facebook, Instagram, LinkedIn and Google Analytics into one beautiful, brand-aware command centre.</p>
        </div>
      </div>
    </div>
  );
}
